import { useEffect, useContext, useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import {
  addLayer,
  fetch,
  fetchLayersRequest,
  key,
  layerResponseFormatter,
  trans,
  updateLayerPropertiesFromConfig,
} from "../../lib/utils";
import Loader from "../loader/loader";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { getLayerById } from "../map/mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import LayerPreviewComponent from "./layerPreviewComponent";

function ServicePreviewComponent(props) {
  const [source, setSource] = useState(null);
  const [availableLayers, setAvailableLayers] = useState(null);
  const [content, setContent] = useState(null);

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const registeredLayerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );

  const formatServiceLayers = (layers) => {
    let _layers = [];

    Object.keys(layers).forEach((el) => {
      let _layer = { ...layers[el] };

      _layers.push(_layer);
    });

    return _layers;
  };

  useEffect(() => {
    if (props.source) {
      setSource(sources[props.source.id]);
    }

    if (source && !availableLayers) {
      fetchLayers();
    }
  }, [source, layers]);

  function fetchLayers() {
    fetch(
      window["appConfig"]()["api"](),
      "POST",
      {},
      [fetchLayersRequest(source)],
      (resp) => {
        let allLayers = {};

        resp.data?.forEach((el) => {
          el._response._layers?.forEach((layer) => {
            allLayers[layer._layerId] = updateLayerPropertiesFromConfig(
              layerResponseFormatter(layer),
              registeredLayerTree
            );
            allLayers[layer._layerId].source = {
              id: el._response._serviceId,
              url: el._response._serviceUrl,
              type: el._response._serviceType,
            };
          });
        });

        setAvailableLayers(formatServiceLayers(allLayers));
      }
    );
  }

  return content ? (
    content
  ) : source ? (
    <PerfectScrollbar style={{ height: "calc(100vh - 25rem)" }}>
      <div className="mt-3 m-2">
        <h4 className="mt-2">{trans("Service information")}</h4>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service Name")}
          </label>
          <div className="mt-2">{source.title}</div>
          <div className="mt-1">
            <span className="text-secondary">{source.url}</span>
          </div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service Type")}
          </label>
          <div className="mt-2">{source.type}</div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service Abstract")}
          </label>
          <div className="mt-2">{source.abstract}</div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service contact information")}
          </label>
          <div className="mt-2">
            <table className="table">
              <thead>
                <tr>
                  <th>{trans("Access constrains")}</th>
                  <th>{trans("Fees")}</th>
                  <th>{trans("Responsible Party")}</th>
                  <th>{trans("Email")}</th>
                  <th>{trans("Person")}</th>
                  <th>{trans("Position")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{source.metadata.access_constrains}</td>
                  <td>{source.metadata.fees}</td>
                  <td>{source.metadata.responsible.party}</td>
                  <td>{source.metadata.responsible.email}</td>
                  <td>{source.metadata.responsible.person}</td>
                  <td>{source.metadata.responsible.position}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Available layers")}
            {availableLayers ? " (".concat(availableLayers.length, ")") : ""}
          </label>
          <div className="mt-2">
            {availableLayers ? (
              <BootstrapTable
                keyField="id"
                key={key()}
                data={availableLayers}
                expandRow={{
                  renderer: (row) => {
                    return row.abstract;
                  },
                  showExpandColumn: true,
                  onlyOneExpanding: true,
                  expandColumnRenderer: ({ expanded, rowKey, expandable }) => {
                    return !expanded ? (
                      <i className="fas fa-plus"></i>
                    ) : (
                      <i className="fas fa-minus"></i>
                    );
                  },
                }}
                columns={[
                  {
                    dataField: "id",
                    text: "",
                    hidden: true,
                  },
                  {
                    dataField: "legend",
                    formatter: function (cell, row) {
                      return (
                        <div className="text-center">
                          <img src={row.legend} width="20" height="20" />
                        </div>
                      );
                    },
                  },
                  {
                    dataField: "layerInfo",
                    formatter: function (cell, row) {
                      return (
                        <div
                          className="text-center"
                          role="button"
                          onClick={() => {
                            setContent(
                              <LayerPreviewComponent
                                key={key()}
                                layer={row}
                              ></LayerPreviewComponent>
                            );
                          }}
                        >
                          <i className="fas fa-info-circle "></i>
                        </div>
                      );
                    },
                  },
                  {
                    dataField: "name",
                    type: "text",
                    text: trans("Name"),
                    filter: textFilter(),
                    sort: true,
                    headerStyle: (colum, colIndex) => {
                      return { width: "15rem", textAlign: "center" };
                    },
                    formatter: function (cell, row) {
                      return (
                        <span role="button" className="text-break">
                          {row.name}
                        </span>
                      );
                    },
                  },
                  {
                    dataField: "title",
                    type: "text",
                    text: trans("Title"),
                    filter: textFilter(),
                    sort: true,
                    formatter: function (cell, row) {
                      return <span role="button">{row.title}</span>;
                    },
                  },
                  {
                    dataField: "_mapId",
                    formatter: function (_cell, row) {
                      return (
                        <div className="text-center">
                          {!getLayerById(row.id) ? (
                            <button
                              className=" btn btn-sm btn-success small text-nowrap"
                              onClick={() => {
                                console.log(row);
                                addLayer(row);
                              }}
                            >
                              <span className="text-white small">
                                <i className="fas fa-plus  me-2 small"></i>
                                {trans("Add to map")}
                              </span>
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm  btn-danger small text-nowrap"
                              onClick={() => {
                                store.dispatch({
                                  type: "layer/deleteById",
                                  payload: row.id,
                                });
                              }}
                            >
                              <span className="text-white small">
                                <i className="fas fa-trash-alt  me-2 small"></i>
                                {trans("Remove from map")}
                              </span>
                            </button>
                          )}
                        </div>
                      );
                    },
                  },
                ]}
                wrapperClasses="bg-white"
                striped
                hover
                filter={filterFactory()}
              />
            ) : (
              <Loader></Loader>
            )}
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  ) : null;
}
export default ServicePreviewComponent;
